<template>
  <div>
    <div class="container" :for="identifier" role="gridcell"  v-if="renderComponent">
      <input
        type="checkbox"
        :checked="isChecked"
        :id="identifier"
        :name="identifier"
        :aria-label="ariaLabel"
        @change="updateAction()"
      />
      <span class="checkmark" :class="{ isPartial: isPartial && !isChecked }" @click="updateAction()"></span>
      <!-- @input="updateAction()" :class="{ isPartial: isPartial }"-->
    </div>
  </div>
</template>

<script>
export default {
  name: "DoeActionBox",
  props: {
    identifier: {
      type: [Number, String],
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    },
    isPartial: {
      type: Boolean
    },
    ariaLabel: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      isChecked: false,
      renderComponent:true
    };
  },
  mounted() {
    this.isChecked = this.isSelected;
  },
  methods: {
    updateAction() {
      let flag=!this.isChecked;
      
      this.isChecked=flag;
      let that=this;
      that.renderComponent = false;
     
      that.$nextTick(function () {
        let p = {
          identifier: that.identifier,
          addToSelected: that.isChecked
        };
        that.$emit("input", p);
        that.renderComponent = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  @apply relative block cursor-pointer font-sans text-base text-gray-900 leading-loose inline-block pl-6 subpixel-antialiased;
  width: 1rem;
  height: 1rem;
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  // font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 2px;
  left: 0;
  height: 1.5rem;
  width: 1.5rem;
  background-color: transparent;
  border-radius: 0.25rem;
  border-width: 2px;
  border-color: #041e42;
  border-style: solid;
}

/* On mouse-over, add a grey background color */
.checkmark:hover {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  /*background-color: #2196F3;*/
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 6px;
  top: 1px;
  width: 8px;
  height: 16px;
  border: solid #041e42;
  border-width: 0 4px 4px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.container .isPartial:after {
  left: 6px;
  top: 1px;
  width: 8px;
  display: block;
  height: 16px;
  border: solid #041e42;
  border-width: 0 4px 0px 0;
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}

input:focus + span.checkmark {
  @apply border-blue-900;
  box-shadow: 0 0 0 1px #041e42;
  outline: 1px solid #041e42;
  outline-offset: 3px;
}
</style>
